import { UserProfile } from '@chr/online-shared-microsite-core/types';

export enum UserProfileActionTypes {
  USER_PROFILE_INIT = 'USER_PROFILE_INIT',
  USER_PROFILE_SET = 'USER_PROFILE_SET',
  USER_PROFILE_RETRIEVAL_FAILED = 'USER_PROFILE_RETRIEVAL_FAILED',
}

// Action Creators
export const getUserProfile = () => ({
  type: UserProfileActionTypes.USER_PROFILE_INIT,
  payload: {},
});

export const setUserProfile = (userProfile: UserProfile) => ({
  type: UserProfileActionTypes.USER_PROFILE_SET,
  payload: userProfile,
});

export const userProfileRetrievalFailed = (error: any) => ({
  type: UserProfileActionTypes.USER_PROFILE_RETRIEVAL_FAILED,
  payload: error,
  error: true,
});
